import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import CustomLink from '../custom-link/CustomLink';
var HeaderGlobal = /*#__PURE__*/function (_React$Component) {
  function HeaderGlobal() {
    _classCallCheck(this, HeaderGlobal);
    return _callSuper(this, HeaderGlobal, arguments);
  }
  _inherits(HeaderGlobal, _React$Component);
  return _createClass(HeaderGlobal, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        id: "global-nav",
        className: "bg-light w-100 flex-grow-1 order-3 order-lg-1"
      }, React.createElement("div", {
        className: "container pb-9 pb-md-0"
      }, React.createElement("div", {
        className: "col d-lg-flex justify-content-lg-between global-nav-wrp position-relative pb-4 pb-md-0"
      }, React.createElement("ul", {
        className: "col-first pt-4 pt-lg-0 pb-3 pb-lg-0 mb-5 mb-lg-0"
      }, React.createElement("li", {
        className: "d-none d-lg-inline pe-lg-6"
      }, React.createElement(CustomLink, {
        isLink: this.props.pageType === 'product',
        href: "/",
        "data-link-both": "globalnav-public-header-consumer"
      }, "Consumer")), React.createElement("li", {
        className: "pe-lg-6"
      }, React.createElement("a", {
        href: "/small-business/",
        "data-link-both": "globalnav-public-header-smallbusiness"
      }, "Small Business")), React.createElement("li", null, React.createElement("a", {
        href: "/business/",
        "data-link-both": "globalnav-public-header-business"
      }, "Business"))), React.createElement("ul", null, this.props.homepage ? React.createElement(Dropdown, {
        drop: "down-centered",
        as: "li",
        autoClose: "outside",
        className: "pe-lg-6",
        focusFirstItemOnShow: "keyboard"
      }, React.createElement(Dropdown.Toggle, {
        as: "button",
        type: "button",
        id: "hmp-nav-crd-support",
        "aria-haspopup": "true",
        className: "btn-reset py-lg-3 pe-lg-4 w-100",
        "data-link-both": "globalnav-public-header-creditsupport"
      }, "Credit Support"), React.createElement(Dropdown.Menu, {
        align: {
          lg: 'start'
        },
        "aria-labelledby": "hmp-nav-crd-support",
        renderOnMount: true,
        as: "ul",
        className: "pb-0 pt-3 py-lg-3"
      }, React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "https://www.annualcreditreport.com/",
        target: "_blank",
        rel: "noreferrer",
        "data-link-both": "globalnav-public-header-cs-freeannualcreditreport"
      }, "Free annual credit report")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/disputes/main.html",
        "data-link-both": "globalnav-public-header-cs-disputes"
      }, "Disputes")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/help/fraud-alert/",
        "data-link-both": "globalnav-public-header-cs-fraudalert"
      }, "Fraud alert")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/help/credit-freeze/",
        "data-link-both": "globalnav-public-header-cs-securityfreeze"
      }, "Security freeze")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/reportaccess/",
        "data-link-both": "globalnav-public-header-cs-deniedcredit"
      }, "Denied credit")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/help/identity-theft-victim-assistance.html",
        "data-link-both": "globalnav-public-header-cs-idtheft"
      }, "ID theft victim assistance")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/lp/military.html",
        "data-link-both": "globalnav-public-header-cs-activemilitary"
      }, "Active duty military")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/blogs/ask-experian/credit-education/faqs/preapproved-credit-offers/opt-out/",
        "data-link-both": "globalnav-public-header-cs-optout"
      }, "Opt out of prescreen offers")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/contact/personal-services-contacts.html",
        "data-link-both": "globalnav-public-header-cs-contactus"
      }, "Contact us")), React.createElement("li", null, React.createElement(Dropdown.Item, {
        href: "/help/",
        "data-link-both": "globalnav-public-header-cs-allcreditsupport"
      }, "See all credit support")))) : React.createElement("li", {
        className: "pe-lg-6"
      }, React.createElement("a", {
        href: "/help/",
        "data-link-both": "globalnav-public-header-cunsumersupport"
      }, "Consumer Support")), React.createElement("li", {
        className: "pe-lg-6"
      }, React.createElement(CustomLink, {
        isLink: this.props.pageType === 'blog',
        href: "/blogs/ask-experian/",
        "data-link-both": "globalnav-public-header-financialadvice"
      }, "Financial Advice")), React.createElement("li", null, React.createElement("a", {
        rel: "noreferrer noopener",
        target: "_blank",
        href: "https://www.experianplc.com/contact-us/region/",
        "data-link-both": "globalnav-public-header-globalsites"
      }, "Global Sites"))))));
    }
  }]);
}(React.Component);
export { HeaderGlobal as default };